import React from 'react'
import './NoRecordsFound.css'

function NoRecordsFound(props) {
    return (
        <h4 className="noRecordsFound">
            <span className="material-icons">find_in_page</span>
            {props?.showText
                ? props.showText
                : 'Sorry, nothing here. But who knows what you will discover with a fresh search?'}
        </h4>
    )
}

export default NoRecordsFound
